import $ from 'jquery';
import {is_float, is_function, is_string, parse_float, parse_int, trim_value} from '../../../Helpers/js/simple.functions';
import UI from '../0-ui';

// ---------- //
// SPINBOX UI //
// ---------- //
UI.Spinbox = {
  timer: 0,

  setup: function (min, max, init, incr, floating, input, spinUpBtn, spinDownBtn, onChanged, canBeEmpty, canBeAnyText, useAutoCorrection, canBePercent) {
    init = parse_float(init);
    var minValue = parse_float(min);
    var maxValue = parse_float(max);

    if (parse_float(min) > parse_float(max)) {
      minValue = parse_float(max);
      maxValue = parse_float(min);
    }

    incr = parse_float(incr);

    var params = {
      init: init,
      min: minValue,
      max: maxValue,
      incr: incr,
      floating: floating,
      input: input,
      isTime: false,
      spinUpBtn: spinUpBtn,
      spinDownBtn: spinDownBtn,
      onChanged: onChanged,
      canBeEmpty: canBeEmpty,
      canBeAnyText: canBeAnyText,
      useAutoCorrection: useAutoCorrection,
      canBePercent: canBePercent,
    };

    UI.Spinbox.init(params);
  },

  init: function (params) {
    params.input
      .keydown(function (e) {
        if (e.keyCode == 9) {
          return;
        }

        if (e.keyCode == 35) {
          UI.Spinbox.setValue(params, params.max, false, true);
        }
        if (e.keyCode == 36) {
          UI.Spinbox.setValue(params, params.min, false, true);
        }

        if ([13, 38, 40].includes(e.keyCode)) {
          UI.Spinbox.startFromDefaultValue(params);
        }

        if (e.keyCode == 38) {
          UI.Spinbox.startSpin(params, true);
          (e.preventDefault(), e.stopPropagation());
        }
        if (e.keyCode == 40) {
          UI.Spinbox.startSpin(params, false);
          (e.preventDefault(), e.stopPropagation());
        }
      })
      .keyup(function (e) {
        if (e.keyCode == 9 || e.keyCode == 16) {
          return;
        }
        UI.Spinbox.stopSpin(params);

        //handle change for direct value inputs which is otherwise done via setValue
        if (![9, 13, 16, 35, 36, 38, 40].includes(e.keyCode)) {
          UI.Spinbox.valueHasChanged(params, this.value);
        }
      });

    params.spinUpBtn
      .click(function () {
        $('input[value="' + $(this).parent().attr('parentid') + '"]').attr('checked', 'checked');
        return false;
      })
      .dblclick(function () {})
      .mousedown(function () {
        UI.Spinbox.startFromDefaultValue(params);
        UI.Spinbox.startSpin(params, true);
      })
      .mouseup(function () {
        UI.Spinbox.stopSpin(params);
      })
      .mouseout(function () {
        UI.Spinbox.stopSpin(params);
      })
      .blur(function () {
        UI.Spinbox.stopSpin(params);
      })
      .keydown(function (e) {
        if ([13, 32, 38].includes(e.keyCode)) {
          UI.Spinbox.startSpin(params, true);
        }
        if (e.keyCode == 35) {
          UI.Spinbox.setValue(params, params.max, false, true);
        }
        if (e.keyCode == 36) {
          params.spinDownBtn.focus();
          UI.Spinbox.setValue(params, params.min, false, true);
        }
        if (e.keyCode == 40) {
          params.spinDownBtn.focus();
          UI.Spinbox.startSpin(params, false);
        }
        if ([13, 32, 35, 36, 38, 40].includes(e.keyCode)) {
          UI.Spinbox.stopPropagation(e);
        }
      })
      .keyup(function () {
        UI.Spinbox.stopSpin(params);
      });

    params.spinDownBtn
      .click(function () {
        $('input[value="' + $(this).parent().attr('parentid') + '"]').attr('checked', 'checked');
        return false;
      })
      .dblclick(function () {})
      .mousedown(function () {
        UI.Spinbox.startFromDefaultValue(params);
        UI.Spinbox.startSpin(params, false);
      })
      .mouseup(function () {
        UI.Spinbox.stopSpin(params);
      })
      .mouseout(function () {
        UI.Spinbox.stopSpin(params);
      })
      .keydown(function (e) {
        if ([13, 32, 40].includes(e.keyCode)) {
          UI.Spinbox.startSpin(params, false);
        }
        if (e.keyCode == 35) {
          params.spinUpBtn.focus();
          UI.Spinbox.setValue(params, params.max, false, true);
        }
        if (e.keyCode == 36) {
          UI.Spinbox.setValue(params, params.min, false, true);
        }
        if (e.keyCode == 38) {
          params.spinUpBtn.focus();
          UI.Spinbox.startSpin(params, true);
        }
        if ([13, 32, 35, 36, 38, 40].includes(e.keyCode)) {
          UI.Spinbox.stopPropagation(e);
        }
      })
      .keyup(function () {
        UI.Spinbox.stopSpin(params);
      })
      .blur(function () {
        UI.Spinbox.stopSpin(params);
      });
  },

  stopPropagation: function (e) {
    e.preventDefault();
    e.stopPropagation();
  },

  startFromDefaultValue: function (params) {
    if (!params.input.val() && params.input[0].placeholder) {
      UI.Spinbox.setValue(params, params.input[0].placeholder, false, true);
    }
  },

  doSpin: function (params, forward) {
    var value = UI.Spinbox.getValue(params);

    var isPercent = is_string(value) ? value.slice(-1) == '%' : false;

    if (!isPercent && isNaN(value)) value = 0;

    if (params.floating) {
      value = parseFloat(value);
      if (forward) {
        value += parseFloat(params.incr);
      } else {
        value -= parseFloat(params.incr);
      }
      value = trim_value(value, 0.0001);
    } else {
      value = parseInt(value, 10);
      if (forward) {
        value += parseInt(params.incr, 10);
      } else {
        value -= parseInt(params.incr, 10);
      }
    }

    if (params.isTime) value = UI.Spinbox.makeTime(value);

    if (isPercent) value += '%';
    UI.Spinbox.setValue(params, value, false, false);
  },

  onSpin: function (params, forward, ms) {
    if (params.input.is('[disabled]')) return;

    window.clearInterval(UI.Spinbox.timer);
    UI.Spinbox.doSpin(params, forward);
    var nextMS = ms;
    if (nextMS > 50) nextMS = nextMS - nextMS / 8;
    UI.Spinbox.timer = window.setInterval(function () {
      UI.Spinbox.onSpin(params, forward, nextMS);
    }, ms);
  },

  startSpin: function (params, forward) {
    if (params.input.is('[disabled]')) return;

    UI.Spinbox.stopSpin(params);
    UI.Spinbox.onSpin(params, forward, 300);
  },

  stopSpin: function (params) {
    if (params.input.is('[disabled]')) return;
    window.clearInterval(UI.Spinbox.timer);
  },

  getValue: function (params) {
    if (params.canBeAnyText) {
      return params.input.val();
    }

    var value = params.input.val();

    if (params.isTime) {
      if (params.canBeEmpty && value == '') {
        return '';
      } else {
        return UI.Spinbox.parseTime(value);
      }
    } else {
      if (is_float(value)) {
        return parse_float(value);
      } else {
        var isPercent = params.canBePercent ? params.input.val().slice(-1) == '%' : false;
        if (isPercent) value = parse_int(value.substr(0, value.length - 1));
        else value = parse_int(value);
        if (isPercent) return value + '%';
        else return value;
      }
    }
  },

  setValue: function (params, value, initOnly, forceRefresh) {
    var prevVal = value;
    var isValid = UI.Spinbox.isValidValue(params, value);

    if (!isValid && params.useAutoCorrection) {
      value = UI.Spinbox.correctValue(params, value);
    }

    prevVal = params.input.val();

    if (prevVal == '' || prevVal != value || forceRefresh) {
      params.input.val(value);
      params.input.change();

      UI.Spinbox.valueHasChanged(params, value);
    }
  },

  valueHasChanged: function (params, value) {
    var isValid = UI.Spinbox.isValidValue(params, value);

    var valueText = params.input.attr('data-valuetext') + ' ' + value;

    params.input[0].setAttribute('aria-valuenow', value);

    if (value === '') {
      params.input[0].removeAttribute('aria-valuetext');
      params.spinDownBtn[0].removeAttribute('aria-description');
      params.spinUpBtn[0].removeAttribute('aria-description');
    } else {
      params.input[0].setAttribute('aria-valuetext', valueText);
      params.spinUpBtn[0].setAttribute('aria-description', valueText);
      params.spinDownBtn[0].setAttribute('aria-description', valueText);
    }

    if (!isValid) {
      params.input.addClass('lp-invalid-input');
      params.input.attr('aria-invalid', true);
      params.spinUpBtn[0].setAttribute('aria-invalid', true);
      params.spinDownBtn[0].setAttribute('aria-invalid', true);
      params.input.attr('aria-description', params.input.attr('errMsg'));
      params.spinUpBtn[0].setAttribute('aria-description', valueText + ': ' + params.input.attr('errMsg'));
      params.spinDownBtn[0].setAttribute('aria-description', valueText + ': ' + params.input.attr('errMsg'));
    } else {
      params.input.removeClass('lp-invalid-input');
      params.input.attr('aria-invalid', false);
      params.spinUpBtn[0].setAttribute('aria-invalid', false);
      params.spinDownBtn[0].setAttribute('aria-invalid', false);
      params.input.removeAttr('aria-description');
    }
    if (is_function(params.onChanged)) params.onChanged(params.input);
  },

  isValidValue: function (params, value) {
    if (params.canBeAnyText) {
      return true;
    }

    if (params.canBeEmpty && value == '' && value != '0') {
      return true;
    }

    if (params.isTime) {
      var sep = value.toString().indexOf(':');
      if (sep == -1) return false;

      var hour = parse_int(value.substr(0, sep));
      if (isNaN(hour) || hour < 0 || hour > 23) return false;

      var minute = parse_int(value.substr(sep + 1));
      if (isNaN(minute) || minute < 0 || minute > 59) return false;
    } else {
      var min = params.min;
      var max = params.max;

      var isPercent = false;
      if (params.canBePercent) {
        const strValue = value.toString();
        isPercent = strValue.slice(-1) == '%';
        if (isPercent) {
          value = parse_int(strValue.substr(0, strValue.length - 1));
          min = 0;
          max = 100;
        }
      }

      var checkVal;

      if (is_float(value)) {
        checkVal = parse_float(value);
      } else {
        checkVal = parse_int(value);
      }

      if (isNaN(checkVal)) return false;

      if (isPercent) {
        if (value < 0 || value > 100) return false;
      } else {
        if (!isNaN(min) && value < min) return false;
        if (!isNaN(max) && value > max) return false;
      }

      if (is_float(value)) {
        value = parse_float(value.toString());
      } // replace , with . and parse back to float

      return checkVal == value;
    }

    return true;
  },

  correctValue: function (params, value) {
    if (params.canBeAnyText) return value;

    var min = params.min;
    var max = params.max;

    if (params.isTime) {
      value = UI.Spinbox.parseTime(value);
      value = value % 1440;
      if (value < 0) value = 1440 + value;
      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) value = max;
      return UI.Spinbox.makeTime(value);
    } else {
      var isPercent = false;
      if (params.canBePercent) {
        isPercent = value.toString().slice(-1) == '%';
        if (isPercent) {
          min = 0;
          max = 100;
        }
      }

      if (is_float(value)) {
        value = parse_float(value);
      } else {
        value = parse_int(value);
      }

      if (!params.floating) {
        value = trim_value(value, params.incr);
      } else {
        value = trim_value(value, 0.0001);
      }

      // Correct not valid value
      if (isNaN(value)) {
        if (params.canBeEmpty) {
          value = '';
        } else {
          if (!isNaN(min) && !isNaN(max)) {
            value = min + (max - min) / 2;
          } else if (!isNaN(min)) {
            value = min;
          } else if (!isNaN(max)) {
            value = max;
          } else {
            value = 0;
          }
          if (!params.floating) value = parse_int(value);
        }
      }

      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) value = max;

      if (isPercent) return value + '%';
      return value;
    }
  },

  parseTime: function (value) {
    var sep = value.indexOf(':');
    if (sep == -1) return 720;

    let hour;
    let minute;
    if (value.charAt(sep - 2) == '0') {
      hour = parse_int(value.slice(sep - 1, sep));
    } else {
      hour = parse_int(value.slice(sep - 2, sep));
    }
    if (isNaN(hour)) hour = 12;

    if (value.charAt(sep + 1) == '0') {
      minute = parse_int(value.slice(sep + 2, sep + 3));
    } else {
      minute = parse_int(value.slice(sep + 1, sep + 3));
    }
    if (isNaN(minute)) minute = 0;

    return hour * 60 + minute;
  },

  makeTime: function (value) {
    if (value < 0) value = 1440;
    if (isNaN(value)) value = 720;
    var hour = Math.floor(value / 60);
    var minute = value % 60;

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;
    return hour + ':' + minute;
  },
};
